import { render, staticRenderFns } from "./PlacementsStartComponentPerformance.vue?vue&type=template&id=77911428&scoped=true&"
import script from "./PlacementsStartComponentPerformance.vue?vue&type=script&lang=js&"
export * from "./PlacementsStartComponentPerformance.vue?vue&type=script&lang=js&"
import style0 from "./PlacementsStartComponentPerformance.vue?vue&type=style&index=0&id=77911428&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77911428",
  null
  
)

export default component.exports